// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"20739783","597":"ef16e357"}[chunkId] + ".chunk.css";
};